import { MinusCircleIcon } from '../../icons';
import validatePassword from '../../lib/validation/passwordValidation';
import MessagingCard from '../MessagingCard';

interface IPasswordChecklistProps {
  /** Current password value to validate */
  password: string;
  /** Confirm password value — when provided, shows a "Matching" checklist item */
  confirmPassword?: string;
  /** Server-side error (e.g. "too common") shown as an additional failed item */
  serverError?: string;
}

const PasswordChecklist = ({ password, confirmPassword, serverError }: IPasswordChecklistProps) => {
  const { rules } = validatePassword(password);

  const showMatchItem = confirmPassword !== undefined;
  const passwordsMatch =
    showMatchItem && password.length > 0 && confirmPassword.length > 0 && password === confirmPassword;

  const items = [
    ...rules.map((rule) => ({ label: rule.label, met: rule.met })),
    ...(showMatchItem ? [{ label: 'Matching', met: passwordsMatch }] : []),
  ];

  return (
    <div className="flex flex-col gap-2">
      <MessagingCard>
        <MessagingCard.Requirements columns={2} items={items} />
      </MessagingCard>

      {serverError && (
        <div className="flex items-center gap-2 px-1">
          <MinusCircleIcon className="text-fg-error-secondary size-4 shrink-0" />
          <span className="text-error-primary text-sm">{serverError}</span>
        </div>
      )}
    </div>
  );
};

PasswordChecklist.displayName = 'PasswordChecklist';

export default PasswordChecklist;
